var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734701040327,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9985,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 256h-64V160c0-17.68-14.32-32-32-32h-192c-17.68 0-32 14.32-32 32v96H384V160c0-17.68-14.32-32-32-32H160c-17.68 0-32 14.32-32 32v96H64c-35.34 0-64 28.66-64 64v512c0 35.34 28.66 64 64 64h896c35.34 0 64-28.66 64-64V320c0-35.34-28.66-64-64-64zM384 528c0 8.84-7.16 16-16 16H144c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32z m512 0c0 8.84-7.16 16-16 16h-80v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80h-80c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h80v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h80c8.84 0 16 7.16 16 16v32z",
    "p-id": 9986,
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.031b05032e1470aeabed3bf824821f04.svg";
export { ForwardRef as ReactComponent };